import { Layout } from "Components/Layout/Layout";
import { DriversContainer } from "Containers/Drivers/DriversContainer";
import React from "react";

export const Drivers = () => {
  return (
    <Layout>
      <DriversContainer />
    </Layout>
  );
};
